import { techStack } from "../../data/techStack";

// Infinite dual-track ticker of the stack. Two identical tracks scroll as one
// so the loop is seamless. dir="ltr" keeps tech names left-to-right in RTL.
const Track = () => (
  <div className="tech-marquee__track" aria-hidden="true">
    {techStack.map((tech, i) => (
      <span className="tech-marquee__item" key={`${tech}-${i}`}>
        {tech}
        <span className="tech-marquee__dot">·</span>
      </span>
    ))}
  </div>
);

const TechMarquee = () => (
  <div className="tech-marquee" dir="ltr">
    <div className="tech-marquee__row">
      <Track />
      <Track />
    </div>
  </div>
);

export default TechMarquee;
